import Vue from 'vue'
import store from '@/store/'
import router from '@/router/'
import FilterPop from './FilterPop'
const Constructor = Vue.extend(FilterPop)
let instance

const filterPop = async({onSuccess, onError,onClose,type,direction,notUserRoleList,selection,onFunc} = {}) => {
    if (typeof beforeCreate == 'function' && !beforeCreate({router, store})) return
    instance = new Constructor({
        propsData: {
            onSuccess,
            onError,
            onClose,
            type,
            direction,
            notUserRoleList,
            selection,
            onFunc
        },
        store,
        router
    })
    instance.vm = instance.$mount()
    var deleteNode = document.querySelector('.filter_pop')
    if(deleteNode != null) {
        document.querySelector('body').removeChild(deleteNode);
        document.querySelector('body').appendChild(instance.vm.$el) // new一个对象，然后插入body里面
    }else {
        document.querySelector('body').appendChild(instance.vm.$el) // new一个对象，然后插入body里面
    }    
    document.querySelector('body').style.overflow = 'hidden'
    instance.vm.$data.isShow = true
    return instance.vm
}
export default filterPop